import { type ComponentType } from "react";

import { WithLoading } from "@vega-core/components/Layout/WithLoading";

import { type BannerItem } from "./components/Banner";
import { LoginLayout } from "./components/LoginLayout";
import { LPLoginForm } from "./LPLoginForm";

type Props = {
  heading?: string;
  headerTitle?: string;
  bannerItems?: BannerItem[];
};

export const LPLogin: ComponentType<Props> = WithLoading(
  ({ heading, headerTitle, bannerItems }: Props) => (
    <LoginLayout bannerItems={bannerItems} headerTitle={headerTitle}>
      <LPLoginForm heading={heading} />
    </LoginLayout>
  ),
);
